import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError, BehaviorSubject } from 'rxjs';
import { catchError, filter, take, switchMap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { LocalStorageService } from '../services/local-storage.service';
import { AuthService } from '../services/auth.service';
import { SessionVariable } from '../enum/session-variable';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {

  private isRefreshing = false;
  private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(
    null
  );

  constructor(
    private router: Router,
    private localStorageService: LocalStorageService,
    private authService: AuthService
  ) { }

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    const TOKENKEY: any = this.localStorageService.getItem(SessionVariable.ACESS_TOKEN) || null;
   

    if (request.url.includes('check_token') || request.url.includes("/accounts/payment/info") || request.url.includes("/accounts/payment/plans/v2") || request.url.includes("/accounts/payment/validate-order-value")) {
      request = this.addBasicToken(request);
    } else {
      if (request.headers.has('refreshtoken')) {
        request = this.addBasicToken(request);
      } else {
        if (request.url.indexOf('/accounts/profile/creditCard') > -1) {
          request = this.addToken(request, TOKENKEY);
        } else {
          if (TOKENKEY) {
            request = this.addToken(request, TOKENKEY);
          } else {
            request = this.addBasicToken(request);
          }
        }
      }
    }

    return next.handle(request).pipe(
      catchError((error) => {
        if (error instanceof HttpErrorResponse && error.status === 401) {
          const errorDesc = error.error.error_description;
          if (errorDesc !== 'Password expired') {
            return this.handle401Error(request, next);
          }
        }

        let errorMsg: any;

        if (error.status === 500) {

        }

        if (request?.responseType == "text") {
          const err = JSON.parse(error.error);
          if (error.status === 500) {
            errorMsg = "Something went wrong, Please try again."
          } else {
            errorMsg = err?.message || err?.error_description || error?.message;
          }

        } else {
          if (error.status === 500) {
            errorMsg = "Something went wrong, Please try again."
          } else {
            errorMsg = error?.error?.message || error?.error?.error_description || error?.message;
          }
        }



        return throwError(errorMsg);

      })
    );
  }

  private addToken(request: HttpRequest<any>, token: string) {
    return request.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
      },
    });
  }

  private addBasicToken(request: HttpRequest<any>) {
    if (request.headers.has('requestFor')) {
      if (request.headers.get('requestFor') == 'merchant') {
        return request.clone({
          setHeaders: {
            Authorization: 'Basic bWVyY2hhbnQ6c2VjcmV0',
            'Accept-Language': this.localStorageService.getItem(SessionVariable.LANGUAGE) == "ar-KW" ? "ar" : "en-US"
          },
        });
      } else {
        return request.clone({
          setHeaders: {
            Authorization: 'Basic YnJvd3NlcjpzZWNyZXQ=',
            'Accept-Language': this.localStorageService.getItem(SessionVariable.LANGUAGE) == "ar-KW" ? "ar" : "en-US"
          },
        });
      }
    } else {
      return request.clone({
        setHeaders: {
          Authorization: 'Basic YnJvd3NlcjpzZWNyZXQ=',
          'Accept-Language': this.localStorageService.getItem(SessionVariable.LANGUAGE) == "ar-KW" ? "ar" : "en-US"
        },
      });
    }
  }

  private handle401Error(request: HttpRequest<any>, next: HttpHandler) {
    if (!this.isRefreshing) {
      this.isRefreshing = true;
      this.refreshTokenSubject.next(null);
      return this.authService.refreshToken().pipe(
        switchMap((token: any) => {
          this.isRefreshing = false;
          this.refreshTokenSubject.next(token.access_token);
          return next.handle(this.addToken(request, token.access_token));
        }),
        catchError((err) => {
          this.localStorageService.clear();
          this.router.navigate(['/consumer/login']);
          return throwError(err);
        })
      );
    } else {
      return this.refreshTokenSubject.pipe(
        filter((token) => token != null),
        take(1),
        switchMap((jwt) => {
          return next.handle(this.addToken(request, jwt));
        }),
        catchError((err) => {
          this.localStorageService.clear();
          this.router.navigate(['/consumer/login']);
          return throwError(err);
        })
      );
    }
  }
}